module.exports = __webpack_public_path__ + "media/ru_ru_s3_Sergey.50ae3c09.mp3";